import React from "react";
import PropTypes from "prop-types";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import SuitIcon from "../../../../../../components/card/suit-icon/SuitIcon";

import "./played-card-bar-item.scss";
import { Button } from "../../../../../../components/button/Button";

// The suits' text colours (darker siblings of the suit colours), at least 4.5:1 on white.
const suitConfig = {
  diamonds: {
    color: "#3f792a",
  },
  hearts: {
    color: "#cd224e",
  },
  spades: {
    color: "#00587d",
  },
  clubs: {
    color: "#886500", // the card's yellow #fbba00, darker
  },
};

const PlayedCardBarItem = ({ card, onChangeCard }) => {
  const { t } = useTranslation("views");
  const suit = card.suit.kind;
  const { color } = suitConfig[suit];

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 50 }}
      className="played-card-bar-item">
      <div className="played-card-bar-item-content">
        <SuitIcon suit={suit} size={24} label={card.suit.title} />
        <div
          className="card-title"
          style={{
            color,
          }}>
          {card.title}
        </div>
        <Button
          className="change-card-button"
          ariaLabel={t("played-cards-bar.change-card", { title: card.title })}
          onClick={onChangeCard}>
          <ChangeCircleIcon fontSize="large" />
        </Button>
      </div>
    </motion.div>
  );
};

PlayedCardBarItem.propTypes = {
  card: PropTypes.object.isRequired,
  onChangeCard: PropTypes.func,
};

export default PlayedCardBarItem;
